import { AxiosResponse } from "axios";
import { normalize, schema } from 'normalizr';
import { createAsyncThunk } from "@reduxjs/toolkit";
import callrecorderApi from '../../api/callrecorderApi';
import callrecorderUrls from "../../configs/callrecorder/callrecorderUrls";
import { CdrInterface } from '../../store/callrecorder/cdrsSlice';

const PREFIX = 'callrecorder';

const processStrategy = (value: any) => {
  return {
    ...value,
    url: callrecorderUrls.cdrPath(value.id)
  };
}

export const cdrsEntity = new schema.Entity(
  'cdrs',
  {},
  {
    processStrategy
  }
);

export const cdrEntity = new schema.Entity(
  'cdr',
  {},
  {
    processStrategy
  }
);

const fetchCdrsCollection = async (url: string, params: object = {}) => {
  const response = await callrecorderApi.get(url, { params })
  const normalized = normalize<
    any,
    {
      cdrs: { [key: string]: CdrInterface };
    }
  >(response.data.cdrs, [cdrsEntity]);

  return {
    cdrs: normalized.entities?.cdrs || {},
    ids: normalized.result,
    count: response.data.meta?.total_count
  };
}

const normalizeInstance = (response: AxiosResponse) => {
  const normalized = normalize<
    any,
    { cdr: CdrInterface; }
  >(response.data.cdr, cdrEntity);
  return normalized.entities;
}

export const fetchCdrs = createAsyncThunk(
  `${PREFIX}_cdrs/fetchCdrs`,
  async (params: object = {}) => fetchCdrsCollection('/onesky/cdrs', params)
);

export const fetchCdr = createAsyncThunk(
  `${PREFIX}_cdrs/fetchCdr`,
  async (id: number | string) => {
    const response = await callrecorderApi.get(`/onesky/cdrs/${id}`);
    return normalizeInstance(response);
  }
);
